<template>
  <div>
    <van-dialog
        v-model="clerkIsChecked"
        title="店员验证"
        :beforeClose="addCheckMobile"
        confirm-button-text="确定"
        :overlay-style="{zIndex:'1000'}"
        style="z-index: 1000"
        >

      <div class="padding-top">
        <van-field
            :border="false"
            class="mobileField"
            label="手机号"
            placeholder="请输入手机号"
            label-width="50px"
        >
          <template slot="input">
            <CommonTelInput :style-classes="{tel:true}" v-model="phoneNumber" :key="phoneNumber.regionCode"
                            :custom-style="{width: '100%',border:'1px solid lightgrey',fontSize:'14px',height:'24px',lineHeight:'24px',padding:'0'}"

                            @validChange="onValidChange"></CommonTelInput>
          </template>
        </van-field>
        <van-field
            v-model="verifyCode"
            center
            clearable
            label="验证码"
            placeholder="短信验证码"
            label-width="50px"
        >
          <template slot="button">
            <van-button size="small" :loading="isBtnLoading" :disabled="isBtnDisabled" type="primary" @click="sendVerifyCode">
                <span v-if="!isBtnDisabled">
                  发送验证码
                </span>
              <span v-else>
                  {{resetCountDown}}秒后可重试
                </span>
            </van-button>
          </template>
        </van-field>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import {Dialog,  Toast, Field, Button} from 'vant';
import CommonTelInput from "@/components/common/tel-input/CommonTelInput";
import {checkedMobile, sendVerifyCode, getClerkApply} from "@/api/firstVerify";

Vue.use(Dialog)
    .use(Toast)
    .use(Field)
    .use(Button)
export default {
  name: 'firstVerify',
  data() {
    return {
      index:'z-index',
      clerkIsChecked: true,
      phoneNumber: {
        regionCode:null,
        mobileDial:null,
        isValid:false,
        mobile: null,
      },
      verifyCode: null,
      resetCountDown: 0,
      resetCountDownTimer: null,
      isBtnDisabled: false,
      isBtnLoading: false,
      clerkApplyId: null,
      status: null,
    };
  },
  components: {
    CommonTelInput
  },
  methods: {
    onValidChange(isValid){
      this.phoneNumber.isValid = isValid;
    },
    addCheckMobile(action, done) {
      let vm = this;
      if (!this.phoneNumber.isValid) {
        done(false)
        Toast("请输入正确的手机号")
        return
      }
      if (action == 'confirm') {
        if(!this.verifyCode){
          done(false)
          Toast("请输入验证码")
          return;
        }
        checkedMobile(
            this.clerkApplyId,
            this.phoneNumber.mobile,
            this.phoneNumber.regionCode,
            this.verifyCode
        ).then((res) => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            done()
            Toast.success('验证成功')
            vm.$router.replace('/')
          } else {
            done(false)
            Toast(data.msg)
          }
        })
      } else {
        done()
      }
    },
    /**
     * 发送验证码
     */
    sendVerifyCode() {
      if (!this.phoneNumber.isValid) {
        Toast("请输入正确的手机号")
        return
      }
      if (this.status != 2) {
        if (this.status == 3) {
          Toast("用户已成为店员，请直接在工作台进入")
        }else {
          Toast("用户还未被添加为店员")
        }
        return
      }
      this.isBtnLoading = true;
      sendVerifyCode(
          this.clerkApplyId,
          this.phoneNumber.mobile,
          this.phoneNumber.regionCode
      ).then(res => {
        const data = res.data
        this.isBtnLoading = false;
        if (data.code == 0) {
          this.resetCountDown=60;
          this.isBtnDisabled = true;
          window.clearInterval(this.resetCountDownTimer)
          this.resetCountDownTimer = setInterval(()=>{
            this.resetCountDown--;
            if(this.resetCountDown<=0){
              this.isBtnDisabled = false;
              window.clearInterval(this.resetCountDownTimer)
            }
          },1000)
          Toast('已发送')
        } else {
          Dialog.alert({
            title: '发送验证码失败',
            message: data.msg
          })
          this.isBtnDisabled = false;
        }
      })
    },
    /**
     * 获取申请状态
     */
    getClerkApply(){
      let vm = this;
      getClerkApply(this.clerkApplyId).then(res => {
        const data = res.data
        if (data.code == 0) {
          if (data.token) {
            Toast.success("用户已成为店员，正在跳转至工作台")
            vm.$router.replace('/set-token?token='+ data.token)
          }
        } else {
          Dialog.alert({
            title: '获取申请状态失败',
            message: data.msg
          })
        }
      })
    }
  },
  mounted() {
    // 兼容新版账号管理
    if(this.$hasFeature('new_account_manage')){
      this.$router.push('/account-verify')
      return;
    }
    var newMobile = this.$route.query.mobile
    var regionCode = this.$route.query.regionCode
    if (newMobile && regionCode) {
      this.phoneNumber = {
        regionCode: regionCode,
        mobile: newMobile,
        isValid: true
      }
    }
    if (this.$route.query.clerkApplyId) {
      this.clerkApplyId = this.$route.query.clerkApplyId
      // 补充 根据clerkApplyId来获取状态店员申请状态
      this.getClerkApply()
    }
    if (this.$route.query.status) {
      this.status = this.$route.query.status
    }
  }
}
</script>

<style lang="less" scoped>
///deep/.iti{
//  display: flex;
//}
//
///deep/.iti__flag-container{
//  position: relative;
//}

/deep/.van-cell__title{
  flex: none;
}

</style>
